module.exports = {
  // it is the template for a new author
  'Anais Urlichs': {
    name: 'Anais Urlichs',
    photo: '/images/post-authors/example.jpg',
    twitterUrl: 'https://twitter.com/AnaisUrlichs',
    bio: "Heya, I'm Anais, a Developer Advocate writing about tech, in particular about DevOps and how to get started in the space. Additional topics include studies, career, and lifestyle.",
  },
};
